import styled from '@emotion/styled';
import { SuperAdminOrder } from '@@types/index';
import { Color } from '@resources/colors';
import { colFlex, rowFlex } from '@styles/flexStyles';
import { formatCurrency, formatKoreanDateTime } from '@utils/formatNumber';
import { getPaymentMethodLabel } from '@constants/data/paymentMethod';
import OrderStatusBadge from './OrderStatusBadge';

const List = styled.div`
  width: 100%;
  gap: 8px;
  ${colFlex()}
`;

const Card = styled.div<{ active: boolean }>`
  background: ${({ active }) => (active ? '#FFF3E7' : Color.WHITE)};
  border: 1px solid ${({ active }) => (active ? Color.KIO_ORANGE : '#f0f0f0')};
  border-radius: 10px;
  padding: 12px 14px;
  gap: 6px;
  cursor: pointer;
  ${colFlex()}
`;

const HeaderRow = styled.div`
  width: 100%;
  gap: 8px;
  ${rowFlex({ align: 'center', justify: 'space-between' })}
`;

const WorkspaceName = styled.span`
  font-weight: 600;
  color: ${Color.BLACK};
  font-size: 13px;
`;

const InfoLine = styled.div`
  font-size: 12px;
  color: ${Color.GREY};
`;

const Price = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${Color.BLACK};
`;

const TimestampLine = styled.div`
  font-size: 11px;
  color: ${Color.HEAVY_GREY};
`;

interface OrdersCardListProps {
  orders: SuperAdminOrder[];
  selectedOrderId: number | null;
  onSelect: (order: SuperAdminOrder) => void;
}

function OrdersCardList({ orders, selectedOrderId, onSelect }: OrdersCardListProps) {
  return (
    <List>
      {orders.map((order) => (
        <Card key={order.id} active={selectedOrderId === order.id} onClick={() => onSelect(order)}>
          <HeaderRow>
            <WorkspaceName>{order.workspaceName}</WorkspaceName>
            <OrderStatusBadge status={order.status} />
          </HeaderRow>
          <InfoLine>
            ID: {order.workspaceId} · {order.tableNumber}번 테이블
          </InfoLine>
          <InfoLine>
            손님: {order.customerName} · 주문 #{order.orderNumber} · 주문 ID: {order.id}
          </InfoLine>
          <InfoLine>송금수단: {getPaymentMethodLabel(order.paymentMethod)}</InfoLine>
          <Price>{formatCurrency(order.totalPrice)}</Price>
          <TimestampLine>{formatKoreanDateTime(order.createdAt)}</TimestampLine>
        </Card>
      ))}
    </List>
  );
}

export default OrdersCardList;
